import axios from "axios";
import { getApiUrlFromEnv, platforms } from "utils/environment.util";
import { ActivityModel, type activityType, type ApiActivityType } from "models/activity.model";
import { getOrchardUrlFromEnv } from "utils/environment.util";

export class ActivitiesService {
    apiUrl = "";
    orchardUrl = "";
    env = process.env.REACT_APP_ENV_VAR ?? "";

    constructor(private runActivity?: (r: activityType, offline: boolean, url: string) => void) {
        this.apiUrl = getApiUrlFromEnv(this.env);
        this.orchardUrl = getOrchardUrlFromEnv(this.env);
    }

    getActivities = async () => {
        const token = sessionStorage.getItem('accessToken');
        if (!token) return;
        return await axios
            .get(
                `${this.apiUrl}/api/groupsessions/attending`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            .then(async (res) => {
                const bo = await res?.data;
                if (res.status === 200) {
                    let activities: activityType[] = [];
                    bo.results.map((r: ApiActivityType) => activities = [...activities, new ActivityModel(r)])
                    return activities;
                }
                throw new Error(bo.error);
            })
            .catch((error) => {
                throw new Error(error);
            });
    };

    launchActivity = (resource: activityType, onClose?: () => void) => {

        let params = new URLSearchParams({
            returnUrl: window.location.href,
            appType: "WEB_APP",
        });

        if (resource.sessionId) {
            switch (resource.type) {
                case 'ACTIVITY':
                    params.append("groupSessionId", resource.sessionId ?? "");
                    break;

                case 'COURSE_ACTIVITY':
                    params.append("activityId", resource.id ?? "");
                    params.append("courseSessionId", resource.sessionId ?? "");
                    params.append("stageOrder", resource.stageOrder?.toString() ?? "");
                    break;

                case 'COURSE_GRAIN':
                    params.append("grainId", resource.id ?? "");
                    params.append("courseSessionId", resource.sessionId ?? "");
                    params.append("stageOrder", resource.stageOrder?.toString() ?? "");
                    break;
            }

        } else { // LIBRARY
            switch (resource.type) {
                case 'ACTIVITY':
                    params.append("activityId", resource.id ?? "");
                    break;

                case 'GRAIN':
                    params.append("grainId", resource.id ?? "");
                    break;
            }

        }

        const url = `${this.orchardUrl}/go?${params.toString()}`;

        if (process.env.REACT_APP_PLATFORM === platforms.WEB) {
            const playerWindow = window.open(url, "_blank");
            if (playerWindow && onClose) {
                const interval = setInterval(() => {
                    if (playerWindow.closed) {
                        clearInterval(interval);
                        onClose();
                    }
                }, 500);
            }
        } else {
            this.runActivity?.(resource, resource.offline, url);
        }

    }

}
